import { cn } from "@/lib/utils";
import { EVENT_STATUS_LABELS, EVENT_STATUS_COLORS, type CalendarEventStatus } from "@cold-crew/shared";

interface EventoStatusBadgeProps {
  status:     CalendarEventStatus;
  className?: string;
}

export function EventoStatusBadge({ status, className }: EventoStatusBadgeProps) {
  return (
    <span className={cn(
      "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium",
      EVENT_STATUS_COLORS[status],
      className
    )}>
      {EVENT_STATUS_LABELS[status]}
    </span>
  );
}
